/**
 * Apply user-resized DataGrid widths. Flex columns ignore `width`, so a
 * persisted pixel width must drop `flex` or the column snaps back.
 */
export function applyPersistedColumnWidths(columns, columnWidths = {}) {
  return columns.map((col) => {
    const updatedCol = { ...col };

    if (col.field === "actions") {
      return updatedCol;
    }

    const savedWidth = Number(columnWidths[col.field]);
    if (Number.isFinite(savedWidth) && savedWidth > 0) {
      updatedCol.width = savedWidth;
      delete updatedCol.flex;
    }

    updatedCol.sortable = true;
    updatedCol.filterable = true;
    updatedCol.resizable = true;
    return updatedCol;
  });
}

export function mergeColumnWidth(prevWidths, field, width) {
  if (!field || !Number.isFinite(width) || width <= 0) {
    return prevWidths;
  }
  return {
    ...prevWidths,
    [field]: width,
  };
}
